import { Component, computed, input } from '@angular/core';
import { AuiColor } from '@ral/utils:core/ui';

@Component({
    selector: 'aui-loading',
    template: `<div class="flex h-full items-center justify-center">
        <div
            class="w-10 h-10 border-4 {{ borderColor() }} border-solid rounded-full animate-spin border-t-transparent"
        ></div>
    </div>`,
    imports: [],
})
export class AuiLoadingComponent {
    color = input<AuiColor>('primary');

    borderColor = computed(() => {
        const color = this.color();
        return 'border-' + color;
    });
}
